/* eslint-disable no-undef */
import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';
import { parse } from 'qs';
import ReactGA from 'react-ga';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    lng: process.env.REACT_APP_LOCALE,
    fallbackLng: 'en',

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    debug: false,
    lowerCaseLng: true,
    initImmediate: false,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    react: {
      wait: true,
    },

    backend: {
      loadPath: './locales/{{lng}}/translations.json',
    },
  });

i18n.on('languageChanged', () => {

  const query = parse(window.location.search, { ignoreQueryPrefix: true });
  const lang = window.location.pathname.replace('/', '');

  if (i18n.language === lang) {
    if (query.distributor !== undefined) {
      ReactGA.initialize(i18n.t('config.DISTRIBUTOR_GA_CODE'));
    } else {
      ReactGA.initialize(i18n.t('config.GA_CODE'));
    }
  }

  ReactGA.ga('set', 'anonymizeIp', true);

});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js